function formatDelimiters(
  number = 0,
  precision = 2,
  thousands = ',',
  decimal = '.',
) {
  if (isNaN(number) || number == null) {
    return 0
  }

  const moneyParts = (number / 100.0).toFixed(precision).split('.')
  const dollars = moneyParts[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1${thousands}`,
  )
  const cents = moneyParts[1] ? `${decimal}${moneyParts[1]}` : ''

  return `${dollars}${cents}`
}

export function formatMoney(amount, suppressCurrencyCode = false) {
  if (typeof amount === 'string') {
    amount = amount.replace('.', '')
  }

  const shopifyMoneyFormatRegex = /\{\{\s*(\w+)\s*}}/
  const format =
    suppressCurrencyCode ?
      SAXX.Shop.MoneyFormat
    : SAXX.Shop.MoneyFormatWithCurrency

  let value
  switch (format.match(shopifyMoneyFormatRegex)[1]) {
    case 'amount_no_decimals':
      value = formatDelimiters(amount, 0)
      break
    case 'amount_with_comma_separator':
      value = formatDelimiters(amount, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatDelimiters(amount, 0, '.', ',')
      break
    case 'amount_with_space_separator':
      value = formatDelimiters(amount, 2, ' ', ',')
      break
    case 'amount_with_apostrophe_separator':
      value = formatDelimiters(amount, 2, "'", ',')
      break
    default:
      value = formatDelimiters(amount, 2)
  }

  return format.replace(shopifyMoneyFormatRegex, value)
}

const imageURLBuilder = (imageUrl) => {
  const [url, query] = imageUrl.split('?')
  const [extension, ...path] = url.split('.').reverse()
  const domainPath = path.reverse().join('.')

  let queryString = ''
  if (query) {
    queryString = `?${query}`
  }

  return {
    domainPath,
    extension,
    queryString,
  }
}

export function imageUrlSizer(imageUrl = '', suffix = null) {
  if (!imageUrl.length > 0) return ''

  let size = suffix || '_175x'
  const { domainPath, extension, queryString } = imageURLBuilder(imageUrl)

  if (domainPath.includes('images.cdn.saxxunderwear')) {
    size = ''
  }

  return `${domainPath}${size}.${extension}${queryString}`
}

export function imageUrlSrcSetSizer(imageUrl = '') {
  if (!imageUrl.length > 0) return ''
  const { domainPath, extension, queryString } = imageURLBuilder(imageUrl)

  return `${domainPath}_140x.${extension}${queryString} 140w, ${domainPath}_280x.${extension}${queryString} 280w, ${domainPath}_360x.${extension}${queryString} 360w, ${domainPath}_450x.${extension}${queryString} 450w, ${domainPath}_750x.${extension}${queryString} 750w, ${domainPath}_1050x.${extension}${queryString} 1050w, ${domainPath}_1400x.${extension}${queryString} 1400w`
}
